import React, { useEffect } from 'react';
import AboutDetail from './AboutDetail';
import DoctorProfile from './DoctorProfile';
import PromoSection from '../Common/PromoSection';
import VisitUsSection from '../Common/VisitUsSection';
import BookVisitSection from '../Common/BookVisitSection';
import IntroSection from '../Common/IntroSection';
import AnimatedSection from '../Common/AnimatedSection';

function About() {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
    return () => {
      document.documentElement.style.scrollBehavior = 'auto';
    };
  }, []);

  return (
    <div className="about">
      <AnimatedSection id='intro' delay={200}>
        <IntroSection 
          title={"ABOUT PRISTINE SMILE"} 
          about={"Building lifetime relationships through positive experiences"} />
      </AnimatedSection>

      <AnimatedSection id='about' delay={400}>
        <AboutDetail />
      </AnimatedSection>

      <AnimatedSection id='profile' delay={600}>
        <DoctorProfile />
      </AnimatedSection>

      <AnimatedSection id='promo' delay={800}>
        <PromoSection />
      </AnimatedSection>

      <AnimatedSection id='visitUs' delay={1000}>
        <VisitUsSection />
      </AnimatedSection>

      <AnimatedSection id='bookVisit' delay={1200}>
        <BookVisitSection />
      </AnimatedSection>
    </div>
  );
}

export default About;